module.exports = __webpack_public_path__ + "static/img/200102.1e872222.png";